import React, { Component } from 'react';

import RegionListItem from './listItemRegion';
import Divider from '@material-ui/core/Divider';


class OhlMenu extends Component {

    shouldComponentUpdate(nextProps, nextState) {
        if(!this.compareLists(this.props.ohlList, nextProps.ohlList) 
            //|| !this.compareLists(this.props.checkedOhlsList, nextProps.checkedOhlsList) 
            || (this.props.filterText, nextProps.filterText && nextProps.filterText !== null && nextProps.filterText !== '')
            || this.props.parentChecked !== nextProps.parentChecked 
            || this.props.checkAll !== nextProps.checkAll 
            || this.state !== nextState){
            return true;
        }
        else{
            return false; 
        }
    }

    compareLists = (list1, list2) => {
        ////NOTE: deep compare is needed
        if(list1.length !== list2.length){
            return false;
        }
        return true;
    }


    render() {

        let filteredOhlList = this.props.ohlList;

        if (this.props.filterText && this.props.filterText.length > 3) {
            filteredOhlList = filteredOhlList.filter(element => element.name.toLowerCase().includes(this.props.filterText.toLowerCase()));
        }

        if (this.props.filterText.toLowerCase().includes('voltage')) {
            let voltage = this.props.filterText.replace(':', '').replace(' ', '').replace('kV', '').replace('Voltage', '').replace('voltage', '');
            filteredOhlList = this.props.ohlList.filter(element => element.voltage === voltage);
        }


        return (

            this.props.regionList.sort().map((r, index) => {

                let filteredRegionOhlList = filteredOhlList.filter(ohl => ohl.regionCode/*region*/ === r.code).map((o) => ({ ohlId: o.assetId, name: o.name, voltage: o.voltage /*o.voltageLevel*/ }));

                return filteredRegionOhlList.length > 0 ?
                    <span key={index}>
                        <RegionListItem
                            key={index}
                            name={r.name + ' (' + filteredRegionOhlList.length + ')'}
                            ohlList={filteredRegionOhlList}
                            onToogleOhlChecked={(ohl, isChecked) => this.props.onToogleOhlChecked(ohl, isChecked)}
                            onToogleOhlsChecked={this.props.onToogleOhlsChecked}
                            centerOHLByName={this.props.centerOHLByName}
                            //centerOHLById={props.centerOHLById}
                            parentChecked={this.props.parentChecked}
                            isSelectable={this.props.isSelectable}
                        />
                        <Divider />
                    </span> : null
            })
        )
    }
}

export default OhlMenu;